import styled, { css } from 'styled-components';
import { Cross } from '@solent-university/solent-icons';
import { animated } from '@react-spring/web';

import {
    Container as HeroImageContainer,
    ImageWrapper as HeroImageWrapper
} from 'Modules/HeroBanner/MakeWaves/Image/Image.styled';
import {
    IconWrapper,
    PlayIcon as VideoPlayIcon,
    StyledLink as TranscriptLink
} from 'Components/Video/Video.styled';

import { EventsSection as OpenDaysEventsSection } from 'Templates/OpenDays/Landing/Landing.styled';
import { Wrapper as Breadcrumbs } from 'Components/Breadcrumbs/Breadcrumbs.styled';

export const Container = styled(HeroImageContainer)<{
    $isVideoPlaying: boolean;
}>`
    ${({ theme, $isVideoPlaying }) => css`
        transition-duration: 350ms;

        ${$isVideoPlaying &&
        css`
            padding-bottom: 2rem;

            @media ${theme.breakpoints.medium.media} {
                ${Breadcrumbs}:has(+ &&) {
                    display: none;
                }
            }

            && + ${OpenDaysEventsSection} {
                padding-top: 2rem;
                margin-top: 0;
            }
        `}
    `}
`;

export const VideoWrapper = styled(animated.div)<{ $isPlaying: boolean }>`
    ${({ theme, $isPlaying }) => css`
        display: none;

        ${$isPlaying &&
        css`
            display: block;
            margin-top: 2rem;
        `}

        @media ${theme.breakpoints.medium.media} {
            display: block;
            position: absolute;
            width: 50%;
            max-width: 47.5rem;
            top: 0;
            bottom: 0;
            right: 0;
            height: auto;
            margin-top: 0;
            z-index: 0;

            ${$isPlaying &&
            css`
                width: 68.75rem;
                max-width: 90%;
            `}
        }
    `}
`;

export const VideoInner = styled.div`
    position: relative;
`;

export const CloseButton = styled.button`
    ${({ theme }) => css`
        position: absolute;
        top: 1rem;
        right: -0.75rem;
        width: 1.5rem;
        height: 1.5rem;
        margin: 0;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2;
        background: ${theme.colors.secondaryContrast.hex};
        border-radius: 50%;
        border: ${theme.commonStyles.brandPixel} solid ${theme.colors.secondary.hex};
        color: ${theme.colors.secondary.hex};
        cursor: pointer;

        &:focus {
            outline: none;
            border: ${theme.commonStyles.brandPixel} solid ${theme.colors.primary.hex};
        }
    `}
`;

export const CloseIcon = styled(Cross)`
    width: 55%;
`;

export const VideoDescription = styled.p`
    ${({ theme }) => css`
        margin-bottom: 0;

        @media ${theme.breakpoints.medium.media} {
            padding-bottom: 2rem;
        }
    `}
`;

export const ImageWrapper = styled(HeroImageWrapper)`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const PlayButton = styled(IconWrapper)`
    ${({ theme }) => css`
        z-index: 1;
        cursor: pointer;
        transition-duration: 0.5s;

        &:hover {
            transform: scale(1.2);
        }

        @media ${theme.breakpoints.large.media} {
            width: 5.5rem;
            height: 5.5rem;
        }
    `}
`;

export const PlayIcon = styled(VideoPlayIcon)`
    ${({ theme }) => css`
        width: 1.25rem;
        height: 1.75rem;

        @media ${theme.breakpoints.medium.media} {
            width: 2.5rem;
            height: 3rem;
        }
    `}
`;

export const StyledTranscriptLink = styled(TranscriptLink)`
    color: inherit;
`;
